import { UserInformation } from 'ha/services/apiV2/types/UserInformation';

export type UserInfoResponse = UserInformation & {
  hasCompleteBillingInformation?: boolean;
};

export enum AuthType {
  login = 'login',
  register = 'register',
}
